//@ts-check
import flatpickr from 'flatpickr';
//import flatpickr from 'vue-flatpickr-component';
//let dictionnaire = {};

import { dictionnaire } from '../../i18n/en';

let langue = '';
let erreurs = [];
let droits = [];

const devises = {
    "USD": { d: 2, symbol: "$" },
    "EUR": { d: 2, symbol: "€" },
    "GBP": { d: 2, symbol: "£" },
    "HKD": { d: 2, symbol: "HK$" },
    "JPY": { d: 0, symbol: "JPY" },
    "CNY": { d: 0, symbol: "CNY" },
}
function getDevise(d) {
    if (d in devises) return devises[d];
    return { d: 2, symbol: d };
}
const formatQt = new Intl.NumberFormat('en');
const formatHt = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 });
const formatPrix = new Intl.NumberFormat('en', { maximumFractionDigits: 2 });

class B2bTraduction {
    static async setSessionDroits(p) {
        //console.log("setSession", p )
        droits = p;
    }
    static async setLangue(p) {
        /* console.log("B2bTraduction", "chargement langue", p)
         const settings = {
             method: 'GET',
             headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
         };
         const fetchResponse = await fetch(`langue/${p}.json`, settings);
         */
        //dictionnaire = {}; //await fetchResponse.json();
        langue = p;
    }
    /**
     * retourne la traduction d'un libellé à partir d'une clé du genre url
     * @param {String} key     clé de recherche : /linelist/edit/button
     * @param {String} prefixe si le chemin est relatif (ne commence pas par un / )
     * @returns   String       traduction
     */
    static traduit(key, prefixe) {
        const keys = key.split("/");
        let o;
        if (!keys[0]) {
            keys.shift();
            o = dictionnaire;
        } else {
            o = dictionnaire[prefixe];
        }
        //
        while (keys.length) {
            if (!o) return B2bTraduction.erreur(key);
            const k = keys.shift()
            if (!k) return B2bTraduction.erreur(key);
            o = o[k]
        }
        return o || B2bTraduction.erreur(key);
    }
    static erreur(p) {
        erreurs.push(p);
        /* console.log("Traduction manquante", langue, p); */
        return "???" + p;
    }
    static toPrix(value, dev) {
        let v = formatHt.format(Number.parseFloat(value)).replace(/\,/g, " ");
        const devise = (dev) ? getDevise(dev) : null;
        if (devise) {
            return v + " " + devise.symbol;
        } else {
            return v;
        }
    }


    static may(value) {
        if (value in droits) return droits[value];
        /* console.log("invalid may : " + value) */
        return false;
    }


    static toDate(value) {

        // https://flatpickr.js.org/instance-methods-properties-elements/#methods

        // import flatpickr from 'flatpickr';
        // import { French } from "flatpickr/dist/l10n/fr.js";

        if (!value) return "";
        let a = flatpickr.parseDate(value, "Ymd");
        if (!a) return "";
        //console.log("👉️ toDate flatpickr : " + flatpickr.formatDate(a, "j-M-Y"));
        return flatpickr.formatDate(a, "j-M-Y");
    }

    static toDateR(value) {
        if (!value) return "";
        let a = value.match(/^([0-9]{2,4})([0-9]{2})([0-9]{2})$/);
        const mois = ['', 'Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jun', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'];
        if (a && a[2] && mois[parseInt(a[2])]) {
            return a[3] + '-' + mois[parseInt(a[2])] + '-' + a[1];
        }
        return "";
    }
}

const setSessionDroits = B2bTraduction.setSessionDroits;
const traduit = B2bTraduction.traduit;
const setLangue = B2bTraduction.setLangue;
const toPrix = B2bTraduction.toPrix;
const toDate = B2bTraduction.toDate;
const may = B2bTraduction.may;
const getDroits = function () {
    const array = [];
    for (let key in droits) if (droits[key]) array.push(key);
    return array;
}
//
const flatPickrConfig = {

    altInput: true,
    altFormat: "j-M-Y",
    dateFormat: "Ymd",
    allowInput: true,
};

export { flatPickrConfig, getDroits, may, setLangue, setSessionDroits as setSessionDroits, toDate, toPrix, traduit };

